import { Device } from '@/models/device';
import { useState } from 'react'

export function useDeviceSelection(filteredDevices: Device[]) {
  const [selectedDevices, setSelectedDevices] = useState<Set<Device>>(new Set());

  const handleSelectDevice = (device: Device) => {
    const newSelected = new Set(selectedDevices);
    
    const existing = Array.from(newSelected).find(d => d.id === device.id);

    if (existing) {
      newSelected.delete(existing);
    } else {
      newSelected.add(device);
    }
    setSelectedDevices(newSelected);
  };

  const handleSelectAll = () => {
    if (selectedDevices.size === filteredDevices.length && filteredDevices.length > 0) {
      setSelectedDevices(new Set());
    } else {
      setSelectedDevices(new Set(filteredDevices));
    }
  };

  const clearSelection = () => {
    setSelectedDevices(new Set());
  };

  return {
    selectedDevices,
    handleSelectDevice,
    handleSelectAll,
    clearSelection
  };
}